export default __webpack_public_path__ + "static/media/03.58a56e12.jpg";